import { Injectable } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';

@Injectable()
export class ArrayValidatorService {
    minLengthArray(min: number) {
        return (control: AbstractControl): {[key: string]: any} => {
            const formArrayControl = control as FormArray;

            if (formArrayControl.controls.length >= min) {
                return null;
            }

            return { 'minLengthArray': { valid: false }};
        };
    }
}
